import { Button } from "../ui/button";

const NAV = [
  { label: "The Journey", href: "#journey", id: "journey" },
  { label: "Why Attend", href: "#why-attend", id: "why-attend" },
  { label: "Experience", href: "#experience", id: "experience" },
  { label: "Event Details", href: "#event-details", id: "event-details" },
  { label: "FAQ", href: "#faq", id: "faq" },
];

export const Header = ({ onReserve }) => (
  <header
    data-testid="site-header"
    className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-fira-deep/70 backdrop-blur-xl"
  >
    <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3">
      <a href="#hero" data-testid="header-logo-link" className="flex items-center gap-3">
        <img src="/fira-logo.png" alt="Fira Worldwide" className="h-8 w-auto invert" />
        <span className="text-[10px] uppercase tracking-[0.35em] text-white/60">
          The New Era
        </span>
      </a>
      <nav className="hidden items-center gap-8 text-sm text-white/60 lg:flex">
        {NAV.map((item) => (
          <a
            key={item.id}
            href={item.href}
            data-testid={`nav-${item.id}-link`}
            className="transition-colors duration-300 hover:text-fira-rose"
          >
            {item.label}
          </a>
        ))}
      </nav>
      <Button
        onClick={onReserve}
        data-testid="header-reserve-btn"
        className="btn-lux rounded-full px-5 py-2 text-xs font-semibold tracking-wider text-white transition-all duration-300 hover:scale-105"
      >
        RESERVE MY SEAT
      </Button>
    </div>
  </header>
);
